export default __webpack_public_path__ + "static/media/W_wdt_c_cap_0.9ddf4dc4.mp3";